import React, { useState } from 'react';
import styles from './index.module.scss';
import http from '@/assets/api/http';
import PropTypes from 'prop-types';
import { Modal, Alert, message } from 'antd';
import { XInfoLabel, XTextArea, XOKButton, XCancelButton } from '@/components/xqxc_ui';

const EDModal = ({
    closeModal,
    modalParams: {
        id = '', type = '', libType = '', libText = '', title = ''
    } = {}
}) => {

    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState(libText);

    const onSubmit = () => {
        setLoading(true);
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.SensitiveWordCheckMisService.updateSensitiveWordLib', { id, libText: content }, 'POST')
            .then(() => {
                message.success('编辑敏感词造作成功');
                setLoading(false);
                closeModal(true);
            })
            .catch(err => {
                message.error(err.message);
                setLoading(false);
            });
    };

    const footerNode = <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {type === 'edit' && <XCancelButton style={{ width: '60px' }} label='取消' onClick={() => closeModal(false)} />}
        <XOKButton style={{ width: '60px', margin: '0 20px' }} label='确认' onClick={type === 'detail' ? () => closeModal(false) : onSubmit} />
    </div>;

    return <Modal
        title={title}
        bodyStyle={{ padding: '20px' }}
        centered
        destroyOnClose
        confirmLoading={loading}
        width={500}
        visible={true}
        onCancel={() => closeModal(false)}
        footer={footerNode}
    >
        <div className={styles.container}>
            <Alert message='请使用#号分隔' type='warning' showIcon />
            <XInfoLabel label='类型：' value={libType} />
            <XTextArea
                inputStyle={{ width: '360PX' }}
                label='词库内容：'
                placeholder='请输入词库内容'
                bindThis={setContent}
                bindName='content'
                value={content}
                disabled={type === 'detail'}
                isRequired={true}
                rows={10}
            />
        </div>
    </Modal>;
};

EDModal.defaultProps = {
    categorySele: [],
};

EDModal.propTypes = {
    closeModal: PropTypes.func.isRequired,//关闭操作
    modalParams: PropTypes.object,
    request: PropTypes.func
};

export default EDModal;